/*
  Ellada : petits composants des sections (carrousel mobile centré avec points).
*/
if (!customElements.get('ellada-carrousel')) {
  class ElladaCarrousel extends HTMLElement {
    connectedCallback() {
      this.piste = this.querySelector('[data-carrousel-piste]');
      this.points = this.querySelector('[data-carrousel-points]');
      if (!this.piste) return;
      this.items = Array.from(this.piste.children);
      this.media = window.matchMedia('(max-width: 749px)');
      this.onScroll = this.onScroll.bind(this);
      this.build = this.build.bind(this);
      this.media.addEventListener('change', this.build);
      this.build();
    }

    disconnectedCallback() {
      if (this.media) this.media.removeEventListener('change', this.build);
      if (this.piste) this.piste.removeEventListener('scroll', this.onScroll);
    }

    build() {
      this.piste.removeEventListener('scroll', this.onScroll);
      if (this.points) this.points.innerHTML = '';
      this.items.forEach((item) => item.style.removeProperty('--ellada-proximite'));
      if (!this.media.matches || this.items.length < 2) return;

      if (this.points) {
        this.points.removeAttribute('aria-hidden');
        this.items.forEach((item, index) => {
          const point = document.createElement('button');
          point.type = 'button';
          point.className = 'ellada-carrousel__point';
          const nom = item.querySelector('.ellada-categories__nom');
          point.setAttribute('aria-label', nom ? nom.textContent.trim() : String(index + 1));
          point.addEventListener('click', () => this.goTo(index));
          this.points.appendChild(point);
        });
      }
      this.piste.addEventListener('scroll', this.onScroll, { passive: true });
      requestAnimationFrame(() => {
        this.goTo(Math.min(1, this.items.length - 1), false);
        this.onScroll();
      });
    }

    goTo(index, smooth = true) {
      const item = this.items[index];
      if (!item) return;
      const left = item.offsetLeft + item.offsetWidth / 2 - this.piste.clientWidth / 2;
      this.piste.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
    }

    onScroll() {
      const centre = this.piste.scrollLeft + this.piste.clientWidth / 2;
      let actif = 0;
      let meilleur = Infinity;
      this.items.forEach((item, index) => {
        const distance = Math.abs(item.offsetLeft + item.offsetWidth / 2 - centre) / item.offsetWidth;
        item.style.setProperty('--ellada-proximite', Math.min(1, distance).toFixed(3));
        if (distance < meilleur) {
          meilleur = distance;
          actif = index;
        }
      });
      if (this.points) {
        Array.from(this.points.children).forEach((point, index) => {
          point.classList.toggle('is-actif', index === actif);
          point.setAttribute('aria-current', index === actif ? 'true' : 'false');
        });
      }
    }
  }
  customElements.define('ellada-carrousel', ElladaCarrousel);
}
